/* ============ PC Builder — Sigma Tiendas ============ */
(function () {
  "use strict";

  var STORE_URL = "https://sigmatiendas.com";
  var DATA_URL = window.PCB_DATA_URL || "data/catalogo.json";

  // ---------- Iconos SVG lineales (estilo del tema, trazo 1.6) ----------
  function svg(inner) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + "</svg>";
  }
  var ICONS = {
    cpu: svg('<rect x="6" y="6" width="12" height="12" rx="2"/><rect x="10" y="10" width="4" height="4"/><path d="M9 2.5v3M15 2.5v3M9 18.5v3M15 18.5v3M2.5 9h3M2.5 15h3M18.5 9h3M18.5 15h3"/>'),
    mobo: svg('<rect x="3" y="3" width="18" height="18" rx="2"/><rect x="7" y="7" width="5" height="5"/><path d="M15.5 7h2.5M15.5 10h2.5M7 16h4M14.5 14.5h3.5v3.5h-3.5z"/>'),
    ram: svg('<rect x="2.5" y="7" width="19" height="8" rx="1.5"/><path d="M6 15v2.5M10 15v2.5M14 15v2.5M18 15v2.5M6.5 10v2M10.2 10v2M13.9 10v2M17.6 10v2"/>'),
    gpu: svg('<rect x="2.5" y="6.5" width="18" height="11" rx="2"/><circle cx="9" cy="12" r="3"/><path d="M9 10.2v-1M9 14.8v1M6.8 12h-1M12.2 12h1M15.5 9.5h2.5M15.5 12.5h2.5M5 17.5V20h5"/>'),
    nvme: svg('<rect x="2.5" y="9" width="19" height="6" rx="1.2"/><path d="M18.5 9v6M6 9v-1.5M9 9v-1.5M12 9v-1.5M15 9v-1.5"/>'),
    ssd: svg('<rect x="4" y="4" width="16" height="16" rx="2.5"/><rect x="8" y="8" width="8" height="5" rx="1"/><path d="M8 16.5h5"/>'),
    hdd: svg('<rect x="4" y="4" width="16" height="16" rx="2.5"/><circle cx="11" cy="11" r="4.5"/><circle cx="11" cy="11" r="1.2"/><path d="M14.2 14.2 17 17.5"/>'),
    caja: svg('<rect x="6" y="2.5" width="12" height="19" rx="2"/><circle cx="12" cy="7" r="1.1"/><path d="M9.5 11.5h5M9.5 14.5h5M9.5 17.5h5"/>'),
    psu: svg('<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="10" cy="12" r="3.6"/><path d="M10 9.6v-1M10 14.4v1M7.4 12h-1M12.6 12h1M16.5 9h2M16.5 12h2"/>'),
    cooler: svg('<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="2"/><path d="M12 10c0-2.6-.8-4.6-2.4-6M14 12c2.6 0 4.6-.8 6-2.4M12 14c0 2.6.8 4.6 2.4 6M10 12c-2.6 0-4.6.8-6 2.4"/>'),
    liquida: svg('<path d="M12 3.5c3 4 5.5 7 5.5 10a5.5 5.5 0 1 1-11 0c0-3 2.5-6 5.5-10z"/><path d="M9.8 13.5a2.6 2.6 0 0 0 2 2.6"/>'),
    fan: svg('<path d="M3.5 8h9.5a2.5 2.5 0 1 0-2.4-3.2M3.5 12.5H17a2.8 2.8 0 1 1-2.6 3.7M3.5 17h6.5a2.2 2.2 0 1 1-2.1 2.8"/>')
  };

  // ---------- Configuración de categorías (filas del builder) ----------
  // dataKey = categoría del catálogo; filtro = subfiltro dentro de la categoría
  var ROWS = [
    {
      key: "cpu", dataKey: "cpu", nombre: "Procesador (CPU)", icon: ICONS.cpu, qty: false,
      tip: "El cerebro de tu PC. Debe coincidir con el socket de la tarjeta madre. Asegúrate de enfriarlo bien con un buen cooler."
    },
    {
      key: "mobo", dataKey: "mobo", nombre: "Tarjeta Madre", icon: ICONS.mobo, qty: false,
      tip: "Conecta todos los componentes. Define el socket del procesador, la generación de RAM (DDR4/DDR5) y el tamaño del case."
    },
    {
      key: "ram", dataKey: "ram", nombre: "Memoria RAM", icon: ICONS.ram, qty: true,
      gate: ["mobo"], gateMsg: "Selecciona primero una Tarjeta Madre",
      tip: "La memoria de trabajo de tu PC. Debe ser de la misma generación (DDR4 o DDR5) que soporta tu tarjeta madre."
    },
    {
      key: "gpu", dataKey: "gpu", nombre: "Tarjeta Gráfica (GPU)", icon: ICONS.gpu, qty: false,
      tip: "Procesa los gráficos para gaming, diseño y video. Verifica que tu fuente de poder tenga suficiente potencia."
    },
    {
      key: "nvme", dataKey: "disco", nombre: "SSD M.2 / NVMe", icon: ICONS.nvme, qty: true,
      filtro: function (p) { return tipoDisco(p) === "NVME"; },
      tip: "El almacenamiento más rápido. Se conecta directo a la tarjeta madre en el slot M.2. Ideal para el sistema operativo y juegos."
    },
    {
      key: "ssd", dataKey: "disco", nombre: "SSD 2.5\"", icon: ICONS.ssd, qty: true,
      filtro: function (p) { return tipoDisco(p) === "SSD"; },
      tip: "Unidad de estado sólido SATA. Más rápida que un disco duro tradicional, perfecta como almacenamiento secundario."
    },
    {
      key: "hdd", dataKey: "disco", nombre: "Disco Duro (HDD)", icon: ICONS.hdd, qty: true,
      filtro: function (p) { return tipoDisco(p) === "HDD"; },
      tip: "Almacenamiento mecánico de gran capacidad y bajo costo. Ideal para archivos, fotos y respaldos."
    },
    {
      key: "case", dataKey: "case", nombre: "Case", icon: ICONS.caja, qty: false,
      tip: "La torre donde se monta todo tu PC. Debe soportar el tamaño (form factor) de tu tarjeta madre: ATX, Micro-ATX o Mini-ITX."
    },
    {
      key: "psu", dataKey: "psu", nombre: "Fuente de Poder (PSU)", icon: ICONS.psu, qty: false,
      tip: "Alimenta todo el sistema. Elige potencia suficiente para tu GPU y CPU (revisa los watts recomendados de tu tarjeta gráfica)."
    },
    {
      key: "cooler", dataKey: "cooler", nombre: "CPU Cooler (aire)", icon: ICONS.cooler, qty: false,
      gate: ["cpu", "mobo"], gateAny: true, gateMsg: "Selecciona primero un Procesador o Tarjeta Madre",
      excl: "liquida", exclMsg: "Elige cooler de aire O refrigeración líquida. Quita la Refrigeración Líquida para usar esta opción.",
      tip: "Disipador de aire para el procesador. Debe ser compatible con el socket de tu CPU. Tu PC usa cooler de aire o refrigeración líquida, no ambos."
    },
    {
      key: "liquida", dataKey: "liquida", nombre: "Refrigeración Líquida", icon: ICONS.liquida, qty: false,
      gate: ["cpu", "mobo"], gateAny: true, gateMsg: "Selecciona primero un Procesador o Tarjeta Madre",
      excl: "cooler", exclMsg: "Elige cooler de aire O refrigeración líquida. Quita el CPU Cooler para usar esta opción.",
      tip: "Enfriamiento líquido All-in-One. Mejor rendimiento térmico para CPUs potentes. Verifica el espacio del radiador en tu case. Tu PC usa cooler de aire o refrigeración líquida, no ambos."
    },
    {
      key: "fan", dataKey: "fan", nombre: "Ventiladores del Case", icon: ICONS.fan, qty: true,
      tip: "Mejoran el flujo de aire dentro del case. Revisa los tamaños soportados (120mm / 140mm)."
    }
  ];

  // ---------- Estado ----------
  var CAT = null;                 // catálogo cargado
  var sel = {};                   // key de fila -> { p: producto, qty: n }
  var modalRow = null;            // fila abierta en el modal
  var modalShown = 24;            // paginación del modal
  var $ = function (id) { return document.getElementById(id); };

  // ---------- Utilidades ----------
  function money(n) {
    return "$" + (Math.round(n * 100) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function asList(v) { return v == null ? [] : (Array.isArray(v) ? v : [v]); }
  function normSocket(s) { return String(s).toUpperCase().replace(/\s+/g, ""); }

  function tipoDisco(p) {
    var t = String(p.specs.tipo_de_disco_duro || "").toUpperCase();
    if (t.indexOf("NVME") >= 0 || t.indexOf("M.2") >= 0) return "NVME";
    if (t.indexOf("HDD") >= 0) return "HDD";
    if (t.indexOf("SSD") >= 0) return "SSD";
    return "";
  }

  // "LGA 1150, 1151, 1700" / "AM4, AM5" / "Socket 939, 754; FM1, AM4" -> lista normalizada
  function expandSockets(str) {
    var out = [];
    String(str).split(/[,;]+/).forEach(function (tok) {
      tok = tok.trim();
      if (!tok) return;
      var m = tok.match(/^LGA\s*([\d\-v]+)$/i);
      if (m) { out.push("LGA" + m[1].toUpperCase()); out._lga = true; return; }
      if (/^[\d\-v]+$/i.test(tok) && out._lga) { out.push("LGA" + tok.toUpperCase()); return; }
      out.push(normSocket(tok.replace(/^SOCKET\s*/i, "")));
      out._lga = false;
    });
    return out;
  }

  function coolerSockets(p) {
    var l = [];
    asList(p.specs.compatibilidad_de_socket_intel).forEach(function (s) { l = l.concat(expandSockets(s)); });
    asList(p.specs.compatibilidad_de_socket_amd).forEach(function (s) { l = l.concat(expandSockets(s)); });
    return l;
  }

  function socketDe(p) {
    var s = asList(p.specs.socket)[0];
    return s ? normSocket(s) : null;
  }
  function ddrDe(p) {
    var g = asList(p.specs.generaci_n_de_ram)[0];
    return g ? String(g).toUpperCase() : null;
  }

  // ---------- Potencia estimada ----------
  // [patrón, consumo TBP (W), fuente recomendada por el fabricante (W)]
  // Consumo = TBP oficial; recomendada = la PSU mínima que publica NVIDIA/AMD/Intel.
  var GPU_WATTS = [
    // GeForce RTX 50
    [/5090/, 575, 1000], [/5080/, 360, 850], [/5070\s*TI/i, 300, 750], [/5070/, 250, 650],
    [/5060\s*TI/i, 180, 600], [/5060/, 145, 550], [/5050/, 130, 550],
    // GeForce RTX 40 / 30
    [/4090/, 450, 850], [/4080/, 320, 750], [/4070\s*TI/i, 285, 700], [/4070/, 200, 650],
    [/4060\s*TI/i, 160, 550], [/4060/, 115, 550],
    [/3090/, 350, 750], [/3080/, 320, 750], [/3070/, 220, 650], [/3060/, 170, 550], [/3050/, 130, 450],
    // NVIDIA RTX PRO / workstation (Blackwell)
    [/RTX\s*PRO\s*6000.*MAX-?Q/i, 300, 750], [/RTX\s*PRO\s*6000/i, 600, 1000],
    [/RTX\s*PRO\s*5000/i, 300, 750], [/RTX\s*PRO\s*4500/i, 200, 650],
    [/RTX\s*PRO\s*4000/i, 140, 550], [/RTX\s*PRO\s*2000/i, 70, 450],
    // Radeon RX 9000 / 7000 / 6000
    [/9070\s*XT/i, 304, 750], [/9070/, 220, 650], [/9060/, 160, 550],
    [/7900\s*XTX/i, 355, 800], [/7900/, 315, 750], [/7800/, 263, 700], [/7700/, 245, 700],
    [/7600/, 165, 550], [/6700/, 230, 650], [/6600/, 132, 500],
    // Radeon RX 6000 bajos / RX 5000
    [/6750/, 250, 650], [/6650/, 180, 500], [/6500/, 107, 400], [/6400/, 53, 350],
    [/5700/, 225, 600], [/5600/, 150, 550], [/5500/, 130, 450],
    // Radeon workstation / legacy
    [/AI\s*PRO\s*R9700/i, 300, 750],
    [/PRO\s*W7900/i, 295, 750], [/PRO\s*W7800/i, 260, 700], [/PRO\s*W7700/i, 190, 600],
    [/PRO\s*W7600/i, 130, 450], [/PRO\s*W7500/i, 70, 400], [/PRO\s*W6[48]00/i, 55, 350],
    [/RX\s*580\b/i, 185, 500], [/RX\s*570\b/i, 150, 450], [/RX\s*560\b/i, 80, 400], [/RX\s*550\b/i, 50, 350],
    [/HD\s*\d{4}/i, 50, 300],
    // NVIDIA RTX A-series / T-series workstation
    [/RTX\s*A6000/i, 300, 750], [/RTX\s*A5[05]00/i, 230, 700], [/RTX\s*A4500/i, 200, 650],
    [/RTX\s*A4000/i, 140, 550], [/RTX\s*A2000/i, 70, 450],
    [/\bT1000\b/i, 50, 300], [/\bT600\b/i, 40, 300], [/\bT400\b/i, 30, 300],
    // Intel Arc
    [/B580/i, 190, 600], [/B570/i, 150, 550], [/A580/i, 185, 600],
    [/ARC\s*PRO\s*B70|ARC\s*PRO\s*B65/i, 150, 550], [/ARC\s*PRO\s*B60/i, 120, 500], [/ARC\s*PRO\s*B50/i, 70, 450],
    [/A770/i, 225, 650], [/A750/i, 225, 600], [/A380/i, 75, 450], [/A310/i, 75, 450],
    // Legacy NVIDIA GeForce
    [/1080\s*TI/i, 250, 600], [/1080/, 180, 500], [/1070/, 150, 500], [/1060/, 120, 400],
    [/1660/, 125, 450], [/1650/, 75, 350], [/1050/, 75, 300], [/GT\s*10[23]0/i, 30, 300],
    [/GT\s*7[13]0/i, 25, 300]
  ];

  function gpuInfo(p) {
    var t = p.t.toUpperCase();
    for (var i = 0; i < GPU_WATTS.length; i++) {
      if (GPU_WATTS[i][0].test(t)) return { w: GPU_WATTS[i][1], rec: GPU_WATTS[i][2] };
    }
    return { w: 250, rec: 650 }; // GPU desconocida: estimación media
  }

  // Consumo pico realista del CPU (PPT en AMD, MTP en Intel), no el TDP de marketing.
  function cpuWatts(p) {
    var t = p.t.toUpperCase();
    if (/THREADRIPPER|XEON/.test(t)) return 350;
    if (/X3D/.test(t)) return 162;               // PPT de los 120W TDP (7800X3D, 9800X3D...)
    if (/RYZEN 9/.test(t)) return 200;           // PPT 9950X / 7950X
    if (/I9|ULTRA 9/.test(t)) return 250;        // MTP i9/Ultra 9 K
    if (/RYZEN 7/.test(t)) return 142;           // PPT 105W TDP
    if (/I7|ULTRA 7/.test(t)) return 220;
    if (/RYZEN 5/.test(t)) return 130;
    if (/I5|ULTRA 5/.test(t)) return 180;
    if (/I3/.test(t)) return 120;
    return 100;
  }

  function wattsDe(rowKey, p, qty) {
    switch (rowKey) {
      case "cpu": return cpuWatts(p);
      case "gpu": return gpuInfo(p).w;
      case "mobo": return 60;
      case "ram": return 5 * qty;
      case "nvme": return 8 * qty;
      case "ssd": return 4 * qty;
      case "hdd": return 8 * qty;
      case "fan": return 3 * qty;
      case "cooler": return 5;
      case "liquida": return 18;
      default: return 0;
    }
  }

  function psuWatts(p) {
    var m = String(p.specs.potencia_de_salida || p.t).match(/(\d{3,4})\s*W/i);
    return m ? parseInt(m[1], 10) : null;
  }

  // Socket elegido del build (mobo manda; si no hay, CPU)
  function socketElegido() {
    if (sel.mobo) return socketDe(sel.mobo.p);
    if (sel.cpu) return socketDe(sel.cpu.p);
    return null;
  }

  // Form factor: el case soporta tarjetas madre de su tamaño o menores.
  var FF_RANK = { MINIITX: 1, MICROATX: 2, MATX: 2, ATX: 3, EATX: 4, CEB: 4, EEB: 5, XLATX: 5 };
  function ffRank(v) {
    if (!v) return null;
    var k = String(v).toUpperCase().replace(/[^A-Z]/g, "");
    return FF_RANK[k] || null;
  }
  function ffDe(p) {
    return ffRank(asList(p.specs.factor_de_forma_de_la_tarjeta_madre)[0]);
  }
  function ffTexto(p) {
    return asList(p.specs.factor_de_forma_de_la_tarjeta_madre)[0] || null;
  }

  function esRamParaPC(p) {
    var cat = asList(p.specs.categor_a_de_memoria)[0];
    if (cat) return cat === "Para PC";
    var t = p.t.toUpperCase();
    return t.indexOf("SO-DIMM") < 0 && t.indexOf("SODIMM") < 0 && t.indexOf("LAPTOP") < 0;
  }

  // ---------- Compatibilidad: ¿el producto p es compatible con el build actual, en la fila row? ----------
  function esCompatible(row, p) {
    var sk = socketElegido();
    switch (row.key) {
      case "cpu":
        if (sel.mobo) { var s = socketDe(p); return !s || s === socketDe(sel.mobo.p); }
        return true;
      case "mobo":
        if (sel.cpu) {
          var s2 = socketDe(p);
          if (s2 && s2 !== socketDe(sel.cpu.p)) return false;
        }
        if (sel.case) {
          var rc = ffDe(sel.case.p), rm = ffDe(p);
          if (rc && rm && rm > rc) return false;
        }
        return true;
      case "case":
        if (sel.mobo) {
          var rc2 = ffDe(p), rm2 = ffDe(sel.mobo.p);
          if (rc2 && rm2 && rm2 > rc2) return false;
        }
        return true;
      case "ram":
        if (!esRamParaPC(p)) return false;
        if (sel.mobo) {
          var gm = ddrDe(sel.mobo.p), gr = ddrDe(p);
          if (gm && gr) return gm === gr;
        }
        return true;
      case "cooler":
      case "liquida":
        if (sk) {
          var lista = coolerSockets(p);
          if (!lista.length) return true; // sin datos: no bloquear
          return lista.indexOf(sk) >= 0;
        }
        return true;
      default:
        return true;
    }
  }

  // Descripción del filtro activo (se muestra en el modal)
  function textoCompat(row) {
    var sk = socketElegido();
    if (row.key === "mobo" && sel.cpu && socketDe(sel.cpu.p))
      return "Mostrando tarjetas madre con socket " + asList(sel.cpu.p.specs.socket)[0] + " (compatibles con tu procesador).";
    if (row.key === "cpu" && sel.mobo && socketDe(sel.mobo.p))
      return "Mostrando procesadores con socket " + asList(sel.mobo.p.specs.socket)[0] + " (compatibles con tu tarjeta madre).";
    if (row.key === "ram" && sel.mobo && ddrDe(sel.mobo.p))
      return "Mostrando memorias " + ddrDe(sel.mobo.p) + " para PC (compatibles con tu tarjeta madre).";
    if ((row.key === "cooler" || row.key === "liquida") && sk)
      return "Mostrando coolers compatibles con el socket " + sk.replace("LGA", "LGA ") + " de tu build.";
    if (row.key === "case" && sel.mobo && ffTexto(sel.mobo.p))
      return "Mostrando cases donde cabe tu tarjeta madre " + ffTexto(sel.mobo.p) + ".";
    return "";
  }

  // ---------- Problemas de compatibilidad del build actual ----------
  // Devuelve [{rows: [keys afectadas], msg}] — vacío si todo es compatible.
  function problemasCompat() {
    var problemas = [];
    if (sel.cpu && sel.mobo) {
      var sc = socketDe(sel.cpu.p), sm = socketDe(sel.mobo.p);
      if (sc && sm && sc !== sm) {
        problemas.push({
          rows: ["cpu", "mobo"],
          msg: "El procesador es socket " + asList(sel.cpu.p.specs.socket)[0] +
            " pero la tarjeta madre es socket " + asList(sel.mobo.p.specs.socket)[0] + "."
        });
      }
    }
    if (sel.ram) {
      if (!esRamParaPC(sel.ram.p)) {
        problemas.push({ rows: ["ram"], msg: "La memoria seleccionada es para laptop (SO-DIMM), no para PC de escritorio." });
      } else if (sel.mobo) {
        var gm = ddrDe(sel.mobo.p), gr = ddrDe(sel.ram.p);
        if (gm && gr && gm !== gr) {
          problemas.push({ rows: ["ram"], msg: "La memoria es " + gr + " pero tu tarjeta madre soporta " + gm + "." });
        }
      }
    }
    if (sel.case && sel.mobo) {
      var rc = ffDe(sel.case.p), rm = ffDe(sel.mobo.p);
      if (rc && rm && rm > rc) {
        problemas.push({
          rows: ["case", "mobo"],
          msg: "La tarjeta madre es " + ffTexto(sel.mobo.p) + " pero el case solo soporta hasta " + ffTexto(sel.case.p) + "."
        });
      }
    }
    if (sel.cooler && sel.liquida) {
      problemas.push({
        rows: ["cooler", "liquida"],
        msg: "Tienes un cooler de aire y una refrigeración líquida a la vez; tu PC solo usa uno. Quita uno de los dos."
      });
    }
    var sk = socketElegido();
    if (sk) {
      ["cooler", "liquida"].forEach(function (k) {
        if (sel[k]) {
          var lista = coolerSockets(sel[k].p);
          if (lista.length && lista.indexOf(sk) < 0) {
            problemas.push({ rows: [k], msg: (k === "cooler" ? "El cooler" : "El enfriamiento líquido") + " no es compatible con el socket " + sk.replace("LGA", "LGA ") + " de tu build." });
          }
        }
      });
    }
    return problemas;
  }

  function filaBloqueada(row) {
    if (!row.gate) return false;
    var tiene = row.gate.filter(function (k) { return !!sel[k]; });
    return row.gateAny ? tiene.length === 0 : tiene.length < row.gate.length;
  }

  function productosDe(row) {
    var lista = CAT.categorias[row.dataKey].productos;
    if (row.filtro) lista = lista.filter(row.filtro);
    return lista;
  }

  // ---------- Render de filas ----------
  function renderRows() {
    var cont = $("pcbRows");
    cont.innerHTML = "";
    var problemas = problemasCompat();
    ROWS.forEach(function (row) {
      var s = sel[row.key];
      // Exclusión aire/líquida: bloqueada si el otro tipo de cooler ya está en el build
      var exclusion = !s && !!(row.excl && sel[row.excl]);
      var bloqueada = filaBloqueada(row) || exclusion;
      var msgBloqueo = exclusion ? row.exclMsg : row.gateMsg;
      var issues = problemas.filter(function (pr) { return pr.rows.indexOf(row.key) >= 0; });
      var div = document.createElement("div");
      div.className = "pcb-row" + (issues.length ? " has-issue" : "");

      var head = document.createElement("div");
      head.className = "pcb-row-head";
      head.innerHTML =
        '<div class="pcb-row-icon">' + row.icon + "</div>" +
        '<div class="pcb-row-name">' +
        '<div class="pcb-cat">' + row.nombre +
        '<span class="pcb-info"><button type="button" aria-label="Más información">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9.2"/><path d="M12 11.2v5"/><path d="M12 7.6h.01"/></svg>' +
        "</button>" +
        '<span class="pcb-info-tip">' + row.tip + "</span></span></div>" +
        '<div class="pcb-hint">' + (bloqueada ? '<span class="pcb-gate">⚠ ' + msgBloqueo + "</span>"
          : (s ? "" : contarDisponibles(row) + " opciones disponibles")) + "</div>" +
        "</div>" +
        '<div class="pcb-row-cta"></div>';

      var cta = head.querySelector(".pcb-row-cta");
      var btn = document.createElement("button");
      btn.className = "pcb-btn pcb-btn-select pcb-btn-sm";
      btn.textContent = s ? "Cambiar" : "Seleccionar";
      btn.disabled = bloqueada;
      btn.addEventListener("click", function () { abrirModal(row); });
      cta.appendChild(btn);
      div.appendChild(head);

      if (s) {
        var picked = document.createElement("div");
        picked.className = "pcb-row-picked";
        picked.innerHTML =
          '<img src="' + (s.p.img || "") + '" alt="" loading="lazy">' +
          '<div class="pcb-picked-info">' +
          '<a href="' + STORE_URL + "/products/" + s.p.h + '" target="_blank" rel="noopener">' + s.p.t + "</a>" +
          '<div class="pcb-picked-meta">' +
          (s.p.sku ? '<span class="pcb-sku">SKU: ' + s.p.sku + "</span>" : "") +
          '<span class="pcb-stock-ok">' + (s.p.qty > 25 ? "25+ EN STOCK" : s.p.qty + " EN STOCK") + "</span></div>" +
          '<div class="pcb-picked-price"><strong>' + money(s.p.p) + "</strong>" +
          (s.p.pc ? "<s>" + money(s.p.pc) + "</s>" : "") +
          (s.qty > 1 ? ' <span class="pcb-muted">× ' + s.qty + " = " + money(s.p.p * s.qty) + "</span>" : "") +
          "</div></div>" +
          '<div class="pcb-picked-actions"></div>';
        var acts = picked.querySelector(".pcb-picked-actions");
        if (row.qty) {
          var q = document.createElement("div");
          q.className = "pcb-qty";
          q.innerHTML = "<button>−</button><span>" + s.qty + "</span><button>+</button>";
          var btns = q.querySelectorAll("button");
          btns[0].addEventListener("click", function () { cambiarQty(row.key, -1); });
          btns[1].addEventListener("click", function () { cambiarQty(row.key, 1); });
          acts.appendChild(q);
        }
        var rm = document.createElement("button");
        rm.className = "pcb-remove";
        rm.textContent = "Quitar";
        rm.addEventListener("click", function () { quitar(row.key); });
        acts.appendChild(rm);
        div.appendChild(picked);
      }
      if (issues.length) {
        var alerta = document.createElement("div");
        alerta.className = "pcb-row-issue";
        alerta.innerHTML = issues.map(function (pr) { return "⚠ " + pr.msg; }).join("<br>");
        div.appendChild(alerta);
      }
      cont.appendChild(div);
    });
  }

  function contarDisponibles(row) {
    return productosDe(row).filter(function (p) { return p.qty > 0 && esCompatible(row, p); }).length;
  }

  // ---------- Selección ----------
  function elegir(rowKey, p) {
    sel[rowKey] = { p: p, qty: (sel[rowKey] && sel[rowKey].qty) || 1 };
    cerrarModal();
    renderAll();
    // No quitamos nada automáticamente: si algo quedó incompatible se marca
    // en rojo en la fila y en el estado de compatibilidad del sidebar.
    var problemas = problemasCompat();
    var mios = problemas.filter(function (pr) { return pr.rows.indexOf(rowKey) >= 0; });
    if (mios.length) toast("⚠ " + mios[0].msg + " Revisa las filas marcadas en rojo.", "warn");
  }

  function quitar(rowKey) { delete sel[rowKey]; renderAll(); }

  function cambiarQty(rowKey, delta) {
    var s = sel[rowKey];
    if (!s) return;
    var max = Math.max(1, s.p.qty);
    s.qty = Math.min(max, Math.max(1, s.qty + delta));
    if (delta > 0 && s.qty === max) toast("Stock máximo disponible: " + max, "warn");
    renderAll();
  }

  // ---------- Resumen ----------
  function renderSummary() {
    var lines = $("pcbSummaryLines");
    var items = ROWS.filter(function (r) { return sel[r.key]; });
    if (!items.length) {
      lines.innerHTML = '<p class="pcb-empty">Aún no has elegido componentes.</p>';
    } else {
      lines.innerHTML = items.map(function (r) {
        var s = sel[r.key];
        return '<div class="pcb-line-item"><span class="n" title="' + s.p.t.replace(/"/g, "&quot;") + '">' + s.p.t +
          (s.qty > 1 ? " ×" + s.qty : "") + '</span><span class="p">' + money(s.p.p * s.qty) + "</span></div>";
      }).join("");
    }
    var total = 0, compare = 0;
    items.forEach(function (r) {
      var s = sel[r.key];
      total += s.p.p * s.qty;
      compare += (s.p.pc || s.p.p) * s.qty;
    });
    $("pcbTotal").textContent = money(total);
    var ahorro = compare - total;
    $("pcbCompareRow").hidden = ahorro <= 0;
    $("pcbSaveRow").hidden = ahorro <= 0;
    if (ahorro > 0) {
      $("pcbCompareTotal").textContent = money(compare);
      $("pcbSaveTotal").textContent = money(ahorro);
    }

    // Estado de compatibilidad (estilo PCPartPicker)
    var compat = $("pcbCompat");
    var problemas = problemasCompat();
    if (!items.length) {
      compat.hidden = true;
    } else if (problemas.length) {
      compat.hidden = false;
      compat.className = "pcb-compat bad";
      compat.innerHTML = "<strong>⚠ " + problemas.length + (problemas.length === 1 ? " problema" : " problemas") +
        " de compatibilidad</strong>" +
        problemas.map(function (pr) { return "<div>• " + pr.msg + "</div>"; }).join("");
    } else {
      compat.hidden = false;
      compat.className = "pcb-compat ok";
      compat.innerHTML = "✔ Sin problemas de compatibilidad";
    }

    // Potencia estimada vs fuente elegida
    var consumo = 0;
    items.forEach(function (r) {
      if (r.key === "psu") return;
      var s = sel[r.key];
      consumo += wattsDe(r.key, s.p, s.qty);
    });
    var warn = $("pcbWattsWarn");
    if (consumo > 0) {
      $("pcbWatts").hidden = false;
      var fuente = sel.psu ? psuWatts(sel.psu.p) : null;
      $("pcbWattsVal").textContent = "~" + consumo + "W" + (fuente ? " / " + fuente + "W" : "");
      // PSU mínima: la recomendación oficial del fabricante de la GPU,
      // o el consumo total +10% si es mayor (builds con CPU muy pesado).
      var recomendada = Math.max(
        sel.gpu ? gpuInfo(sel.gpu.p).rec : 0,
        Math.ceil(consumo * 1.1 / 50) * 50
      );
      if (fuente && fuente < recomendada) {
        warn.hidden = false;
        warn.textContent = "⚠ Tu fuente de " + fuente + "W podría quedarse corta. Recomendamos al menos " +
          recomendada + "W para este build.";
      } else {
        warn.hidden = true;
      }
    } else {
      $("pcbWatts").hidden = true;
      warn.hidden = true;
    }

    $("pcbAddAll").disabled = !items.length;
    $("pcbShare").disabled = !items.length;
    $("pcbPrint").disabled = !items.length;
    $("pcbClear").disabled = !items.length;

    // Progreso del build
    $("pcbProgressLabel").textContent = items.length + " de " + ROWS.length + " componentes";
    $("pcbProgressFill").style.width = Math.round(items.length / ROWS.length * 100) + "%";

    // Barra móvil
    var mb = $("pcbMobileBar");
    if (items.length) {
      mb.classList.add("visible");
      $("pcbMbCount").textContent = items.length + (items.length === 1 ? " componente" : " componentes");
      $("pcbMbTotal").textContent = money(total);
    } else {
      mb.classList.remove("visible");
    }

    actualizarURL();
  }

  function renderAll() { renderRows(); renderSummary(); }

  // ---------- Modal ----------
  function abrirModal(row) {
    modalRow = row;
    modalShown = 24;
    $("pcbModalTitle").textContent = row.nombre;
    $("pcbModalCompat").textContent = textoCompat(row);
    $("pcbSearch").value = "";
    $("pcbSort").value = "rel";
    $("pcbStock").checked = true;
    $("pcbNoCompat").checked = false;
    $("pcbNoCompatWrap").hidden = !textoCompat(row);
    // marcas
    var marcas = {};
    productosDe(row).forEach(function (p) { if (p.v) marcas[p.v] = 1; });
    $("pcbBrand").innerHTML = '<option value="">Todas las marcas</option>' +
      Object.keys(marcas).sort().map(function (m) { return "<option>" + m + "</option>"; }).join("");
    $("pcbModal").hidden = false;
    document.body.style.overflow = "hidden";
    renderGrid();
    $("pcbSearch").focus();
  }

  function cerrarModal() {
    $("pcbModal").hidden = true;
    document.body.style.overflow = "";
    modalRow = null;
  }

  function listaFiltrada() {
    var row = modalRow;
    var q = $("pcbSearch").value.trim().toLowerCase();
    var marca = $("pcbBrand").value;
    var soloStock = $("pcbStock").checked;
    var sinCompat = $("pcbNoCompat").checked;
    var lista = productosDe(row).filter(function (p) {
      if (!sinCompat && !esCompatible(row, p)) return false;
      if (soloStock && p.qty <= 0) return false;
      if (marca && p.v !== marca) return false;
      if (q) {
        var hay = (p.t + " " + (p.v || "") + " " + (p.sku || "")).toLowerCase();
        var partes = q.split(/\s+/);
        for (var i = 0; i < partes.length; i++) if (hay.indexOf(partes[i]) < 0) return false;
      }
      return true;
    });
    var orden = $("pcbSort").value;
    if (orden === "pa") lista.sort(function (a, b) { return a.p - b.p; });
    else if (orden === "pd") lista.sort(function (a, b) { return b.p - a.p; });
    else if (orden === "az") lista.sort(function (a, b) { return a.t.localeCompare(b.t); });
    else lista.sort(function (a, b) { return (b.qty > 0) - (a.qty > 0) || a.p - b.p; });
    return lista;
  }

  function specLinea(row, p) {
    var s = p.specs, parts = [];
    if (row.key === "cpu") { parts.push(asList(s.socket)[0]); }
    else if (row.key === "mobo") { parts.push(asList(s.socket)[0], asList(s.generaci_n_de_ram)[0], s.factor_de_forma_de_la_tarjeta_madre); }
    else if (row.key === "ram") { parts.push(asList(s.generaci_n_de_ram)[0], asList(s.memoria_ram)[0]); }
    else if (row.dataKey === "disco") { parts.push(s.tipo_de_disco_duro, asList(s.disco_duro)[0]); }
    else if (row.key === "psu") { parts.push(s.potencia_de_salida, s.certificaci_n_de_eficiencia); }
    else if (row.key === "case") { parts.push(asList(s.tama_o_del_case)[0], s.factor_de_forma_de_la_tarjeta_madre ? "Hasta " + asList(s.factor_de_forma_de_la_tarjeta_madre)[0] : null); }
    else if (row.key === "liquida") { parts.push(s.tamano_del_radiador ? "Radiador " + asList(s.tamano_del_radiador)[0] : null); }
    else if (row.key === "gpu") { parts.push(asList(s.tama_o_de_la_memoria_gr_fica)[0]); }
    else if (row.key === "fan") { parts.push(asList(s.tamano_del_ventilador)[0]); }
    return parts.filter(Boolean).join(" · ");
  }

  function renderGrid() {
    var lista = listaFiltrada();
    var grid = $("pcbGrid");
    var mostrar = lista.slice(0, modalShown);
    if (!mostrar.length) {
      grid.innerHTML = '<p class="pcb-empty" style="grid-column:1/-1;padding:30px;text-align:center">No encontramos productos con esos filtros.</p>';
    } else {
      grid.innerHTML = mostrar.map(function (p, i) {
        var ahorro = p.pc && p.pc > p.p ? p.pc - p.p : 0;
        var stockTxt = p.qty > 25 ? "25+ EN STOCK" : (p.qty > 3 ? p.qty + " EN STOCK" : (p.qty > 0 ? "¡Solo " + p.qty + " en stock!" : "Agotado"));
        var incompat = $("pcbNoCompat").checked && !esCompatible(modalRow, p);
        return '<div class="pcb-card' + (incompat ? " incompat" : "") + '">' +
          '<img src="' + (p.img || "") + '" alt="" loading="lazy">' +
          '<div class="t">' + p.t + "</div>" +
          '<div class="specs">' + specLinea(modalRow, p) + (p.sku ? '<span class="pcb-sku"> · SKU ' + p.sku + "</span>" : "") + "</div>" +
          '<div class="stock ' + (p.qty > 0 ? "ok" : "out") + '">' + stockTxt + "</div>" +
          (ahorro ? '<div class="save"><s>' + money(p.pc) + "</s> AHORRA " + money(ahorro) + "</div>" : "") +
          '<div class="price">' + money(p.p) + "</div>" +
          (incompat ? '<div class="incompat-note">⚠ No compatible con tu build</div>' : "") +
          '<button class="pcb-btn pcb-btn-select pcb-btn-sm" data-i="' + i + '"' + (p.qty > 0 ? "" : " disabled") + ">ELEGIR</button>" +
          "</div>";
      }).join("");
      grid.querySelectorAll("button[data-i]").forEach(function (b) {
        b.addEventListener("click", function () {
          elegir(modalRow.key, mostrar[parseInt(b.getAttribute("data-i"), 10)]);
        });
      });
    }
    $("pcbMore").hidden = lista.length <= modalShown;
    $("pcbMore").textContent = "Ver más productos (" + (lista.length - modalShown > 0 ? lista.length - modalShown : 0) + " restantes)";
  }

  // ---------- Builds sugeridos ----------
  function pickPercentil(lista, pct) {
    var conStock = lista.filter(function (p) { return p.qty > 0; }).sort(function (a, b) { return a.p - b.p; });
    if (!conStock.length) return null;
    return conStock[Math.min(conStock.length - 1, Math.floor(conStock.length * pct))];
  }

  function armarPreset(pct) {
    var build = {};
    var cpus = CAT.categorias.cpu.productos.filter(function (p) {
      var s = socketDe(p);
      return p.qty > 0 && (s === "AM4" || s === "AM5" || s === "LGA1700" || s === "LGA1851");
    });
    var cpu = pickPercentil(cpus, pct);
    if (!cpu) return null;
    build.cpu = cpu;
    var sk = socketDe(cpu);
    var mobos = CAT.categorias.mobo.productos.filter(function (p) { return socketDe(p) === sk; });
    build.mobo = pickPercentil(mobos, pct);
    if (build.mobo) {
      var gen = ddrDe(build.mobo);
      var rams = CAT.categorias.ram.productos.filter(function (p) {
        return esRamParaPC(p) && (!gen || ddrDe(p) === gen);
      });
      build.ram = pickPercentil(rams, pct);
    }
    build.gpu = pickPercentil(CAT.categorias.gpu.productos, pct);
    build.nvme = pickPercentil(CAT.categorias.disco.productos.filter(function (p) { return tipoDisco(p) === "NVME"; }), pct);
    if (build.mobo) {
      var rmMobo = ffDe(build.mobo);
      build.case = pickPercentil(CAT.categorias.case.productos.filter(function (p) {
        var rcCase = ffDe(p);
        return !rcCase || !rmMobo || rcCase >= rmMobo;
      }), pct);
    }
    build.psu = pickPercentil(CAT.categorias.psu.productos, pct);
    var coolers = CAT.categorias[pct >= 0.7 ? "liquida" : "cooler"].productos.filter(function (p) {
      var l = coolerSockets(p);
      return !l.length || l.indexOf(sk) >= 0;
    });
    build[pct >= 0.7 ? "liquida" : "cooler"] = pickPercentil(coolers, pct);
    return build;
  }

  var PRESETS = [
    { nombre: "Básico", pct: 0.12, desc: "Un sistema confiable de entrada, perfecto para el día a día, tareas de oficina y navegación fluida." },
    { nombre: "Avanzado", pct: 0.45, desc: "Un build de rango medio, ideal para multitarea, gaming moderado y trabajo creativo como edición de fotos." },
    { nombre: "Pro", pct: 0.8, desc: "Un build de alta gama para gaming 4K, renderizado y multitarea pesada, con refrigeración líquida." }
  ];

  function renderPresets() {
    var cont = $("pcbSuggested");
    cont.innerHTML = "";
    PRESETS.forEach(function (pr) {
      var build = armarPreset(pr.pct);
      if (!build) return;
      var total = 0;
      Object.keys(build).forEach(function (k) { if (build[k]) total += build[k].p; });
      var btn = document.createElement("button");
      btn.className = "pcb-preset";
      btn.innerHTML = "<h4>" + pr.nombre + "</h4><p>" + pr.desc + "</p>" +
        '<span class="pcb-preset-price">Desde ' + money(total) + "</span>";
      btn.addEventListener("click", function () {
        sel = {};
        Object.keys(build).forEach(function (k) { if (build[k]) sel[k] = { p: build[k], qty: 1 }; });
        renderAll();
        toast('Build "' + pr.nombre + '" cargado. Ajusta cualquier componente a tu gusto.', "ok");
        document.querySelector(".pcb-components").scrollIntoView({ behavior: "smooth" });
      });
      cont.appendChild(btn);
    });
  }

  // ---------- Compartir / URL ----------
  function actualizarURL() {
    var partes = [];
    ROWS.forEach(function (r) {
      var s = sel[r.key];
      if (s) partes.push(r.key + ":" + s.p.vid + ":" + s.qty);
    });
    var url = new URL(window.location.href);
    if (partes.length) url.searchParams.set("b", partes.join("."));
    else url.searchParams.delete("b");
    window.history.replaceState(null, "", url.toString());
  }

  function cargarDeURL() {
    var b = new URL(window.location.href).searchParams.get("b");
    if (!b) return;
    var porVid = {};
    Object.keys(CAT.categorias).forEach(function (ck) {
      CAT.categorias[ck].productos.forEach(function (p) { porVid[String(p.vid)] = p; });
    });
    b.split(".").forEach(function (parte) {
      var seg = parte.split(":");
      if (seg.length < 2) return;
      var rowKey = seg[0], vid = seg[1], qty = parseInt(seg[2] || "1", 10) || 1;
      var row = null;
      for (var i = 0; i < ROWS.length; i++) if (ROWS[i].key === rowKey) row = ROWS[i];
      var p = porVid[vid];
      if (row && p) sel[rowKey] = { p: p, qty: qty };
    });
  }

  // ---------- Carrito ----------
  function agregarAlCarrito() {
    var items = [];
    ROWS.forEach(function (r) {
      var s = sel[r.key];
      if (s) items.push({ id: s.p.vid, quantity: s.qty });
    });
    if (!items.length) return;
    var enTienda = /sigmatiendas|sigma-tiendas/.test(window.location.hostname);
    if (enTienda) {
      var btn = $("pcbAddAll");
      btn.disabled = true;
      btn.textContent = "Agregando...";
      var intentar = function (reintento) {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) {
            if (!reintento) {
              // Un reintento con pausa (rate limit / red)
              return new Promise(function (res) { setTimeout(res, 1600); }).then(function () { return intentar(true); });
            }
            throw new Error("cart " + r.status);
          }
          toast("¡Build agregado al carrito! 🎉", "ok");
          setTimeout(function () { window.location.href = "/cart"; }, 900);
        });
      };
      intentar(false).catch(function () {
        toast("No se pudo agregar al carrito. Intenta de nuevo en unos segundos.", "warn");
      }).finally(function () {
        btn.disabled = false;
        btn.textContent = "AGREGAR AL CARRITO";
      });
    } else {
      // Fuera de la tienda: cart permalink (reemplaza el carrito actual)
      var permalink = STORE_URL + "/cart/" + items.map(function (i) { return i.id + ":" + i.quantity; }).join(",");
      window.open(permalink, "_blank");
    }
  }

  function imprimirLista() {
    var filas = "";
    var total = 0;
    ROWS.forEach(function (r) {
      var s = sel[r.key];
      if (!s) return;
      total += s.p.p * s.qty;
      filas += "<tr><td>" + r.nombre + "</td><td>" + s.p.t + "</td><td>" + (s.p.sku || "-") +
        "</td><td>" + s.qty + "</td><td style='text-align:right'>" + money(s.p.p * s.qty) + "</td></tr>";
    });
    var w = window.open("", "_blank");
    w.document.write(
      "<html><head><title>Mi build - Sigma Tiendas</title><style>" +
      "body{font-family:Segoe UI,Arial,sans-serif;padding:30px;color:#1a2130}" +
      "h1{font-size:1.3rem}table{border-collapse:collapse;width:100%;margin-top:16px;font-size:.9rem}" +
      "th,td{border:1px solid #ccc;padding:8px 10px;text-align:left}th{background:#f0f3f9}" +
      "tfoot td{font-weight:700}.link{margin-top:18px;font-size:.8rem;color:#555;word-break:break-all}" +
      "</style></head><body><h1>Mi build — sigmatiendas.com</h1>" +
      "<table><thead><tr><th>Componente</th><th>Producto</th><th>SKU</th><th>Cant.</th><th>Precio</th></tr></thead>" +
      "<tbody>" + filas + "</tbody>" +
      "<tfoot><tr><td colspan='4'>Total del build</td><td style='text-align:right'>" + money(total) + "</td></tr></tfoot></table>" +
      "<p class='link'>Link del build: " + window.location.href + "</p>" +
      "<script>window.print()<\/script></body></html>"
    );
    w.document.close();
  }

  function compartir() {
    var url = window.location.href;
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      toast("Link copiado. ¡Comparte tu build! 🔗", "ok");
    }).catch(function () {
      window.prompt("Copia el link de tu build:", url);
    });
  }

  // ---------- Toast ----------
  var toastTimer = null;
  function toast(msg, tipo) {
    var t = $("pcbToast");
    t.textContent = msg;
    t.className = "pcb-toast" + (tipo ? " " + tipo : "");
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3800);
  }

  // ---------- Init ----------
  function init() {
    fetch(DATA_URL).then(function (r) { return r.json(); }).then(function (data) {
      CAT = data;
      cargarDeURL();
      renderPresets();
      renderAll();
    }).catch(function (e) {
      $("pcbRows").innerHTML = '<p class="pcb-empty">No se pudo cargar el catálogo. Recarga la página.</p>';
      console.error(e);
    });

    $("pcbAddAll").addEventListener("click", agregarAlCarrito);
    $("pcbMbAdd").addEventListener("click", agregarAlCarrito);
    $("pcbShare").addEventListener("click", compartir);
    $("pcbPrint").addEventListener("click", imprimirLista);
    $("pcbClear").addEventListener("click", function () { sel = {}; renderAll(); });
    $("pcbNoCompat").addEventListener("change", function () { modalShown = 24; renderGrid(); });
    $("pcbSearch").addEventListener("input", function () { modalShown = 24; renderGrid(); });
    $("pcbBrand").addEventListener("change", function () { modalShown = 24; renderGrid(); });
    $("pcbSort").addEventListener("change", function () { renderGrid(); });
    $("pcbStock").addEventListener("change", function () { modalShown = 24; renderGrid(); });
    $("pcbMore").addEventListener("click", function () { modalShown += 24; renderGrid(); });
    document.querySelectorAll("[data-close]").forEach(function (el) {
      el.addEventListener("click", cerrarModal);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !$("pcbModal").hidden) cerrarModal();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
